import { Component, OnInit } from '@angular/core';
import { CommonModule, Location as AngularLocation } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Item, ShopCategory } from 'src/app/shared/models/items.model';
import { ActivatedRoute, Router } from '@angular/router';
import { ItemSelectorComponent } from 'src/app/shared/components/item-selector/item-selector.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatInputModule } from '@angular/material/input';
import { JsonReaderService } from 'src/app/services/json-reader/json-reader.service';
import { AlbionImageService } from 'src/app/services/albion-image/albion-image.service';

@Component({
  selector: 'app-repair-cost',
  imports: [CommonModule, MatInputModule, FormsModule, ItemSelectorComponent, MatFormFieldModule, MatProgressSpinnerModule],
  templateUrl: './repair-cost.component.html',
  styleUrls: ['./repair-cost.component.scss'],
})
export class RepairCostComponent implements OnInit {
  shopCategories: ShopCategory[] | null = null;
  items: Item[] | null = [];

  selectedCategory: ShopCategory | null = null;
  selectedSubCategory: ShopCategory | null = null;
  selectedSubCategory2: ShopCategory | null = null;
  selectedTier: number | null = null;

  itemValue: number = 0;
  damage: number = 5;
  get repairPerDamage(): number {
    return this.itemValue / 7;
  }
  get repairTotal(): number {
    return this.repairPerDamage * this.damage;
  }

  private _selectedItem!: Item | null;
  set selectedItem(item: Item | null) {
    if (item !== this._selectedItem) {
      this._selectedItem = item;
      let currentPath = this.router.url.split('/')[1]; // Gets the base path segment

      if (this.selectedItem) {
        this.itemValue = this.jsonReaderService.getItemValue(this.selectedItem);
      } else {
        this.itemValue = 0;
      }
      if (item?.uniqueName) {
        this.router.navigate([currentPath, item.uniqueName]);
      } else {
        this.router.navigate([currentPath]);
      }
    }
  }
  get selectedItem(): Item | null {
    return this._selectedItem;
  }

  urlUniqueName!: string;
  isLoading: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private urlLocation: AngularLocation,
    private jsonReaderService: JsonReaderService,
    private albionImageService: AlbionImageService
  ) {}

  ngOnInit(): void {
    this.jsonReaderService.ensureLoaded();
    this.jsonReaderService.itemsData$.subscribe((x) => (this.items = x.filter((x) => x.durability)));
    this.jsonReaderService.shopCategoriesData$.subscribe((x) => {
      this.shopCategories = x.filter((x) => this.categoryHasDurabilityItems(x));
      for (let cat of this.shopCategories) {
        cat.subCategories = cat.subCategories.filter((x) => this.subCategoryHasDurabilityItems(x));
        for (let subCat1 of cat.subCategories) {
          subCat1.subCategories = subCat1.subCategories.filter((x) => this.subCategory2HasDurabilityItems(x));
        }
      }
    });
    this.jsonReaderService.hasLoaded$.subscribe((hasLoaded) => {
      this.isLoading = !hasLoaded;
      if (hasLoaded) {
        this.urlUniqueName = this.route.snapshot.paramMap.get('uniqueName') ?? '';
        if (this.urlUniqueName) {
          let urlItem = this.jsonReaderService.getItemFromIndex(this.urlUniqueName);
          if (urlItem) {
            let urlTier = urlItem.tier;
            if (urlTier && urlItem.shopCategory && urlItem.shopSubCategory1) {
              this.selectedCategory = urlItem.shopCategory;
              this.selectedSubCategory = urlItem.shopSubCategory1;
              this.selectedSubCategory2 = urlItem.shopSubCategory2 ?? null;
              this.selectedTier = urlTier;
              this.selectedItem = urlItem;
            }
          }
        }
      }
    });
  }
  private categoryHasDurabilityItems(category: ShopCategory): boolean {
    if (this.items) {
      return this.items.some((x) => x.shopCategory === category && x.durability);
    }
    return false;
  }

  private subCategoryHasDurabilityItems(subCategory: ShopCategory): boolean {
    if (this.items) {
      return this.items.some((x) => x.shopSubCategory1 === subCategory && x.durability);
    }
    return false;
  }

  subCategory2HasDurabilityItems(subCategory: ShopCategory): boolean {
    if (this.items) {
      return this.items.some((x) => x.shopSubCategory2 === subCategory && x.durability);
    }
    return false;
  }

  getItemImageUrl(item: Item): string {
    return this.albionImageService.getItemImageUrl(item.uniqueName, 0, 75);
  }
}
